import Box from "@mui/material/Box";
import {FormControl} from "@mui/material";
import TransparentButton from "./CommonComponents/TransparentButton/TransparentButton";
import Grid from "@mui/material/Grid";
import {useTheme} from "../../contexts/theme";
import StyledTimeField from "./CommonComponents/StyledTimeField/StyledTimeField";

export default function TrimPointsFields({disableSetTrimPoints, trimPoints, onChangeTrimPoints, onSetTrimPoints, resetTrimPoints, restoreTrimPoints, disableRestoreTrimPoints}){
    const theme = useTheme();

    function handleChangeTrimPoints(typeTrimPoint, newSecond) {
        if (typeTrimPoint === 'start') {
            const tp = {
                start : newSecond,
                end: trimPoints[0] !== undefined ? trimPoints[0].end : newSecond + 60
            }
            onChangeTrimPoints(tp)
        }else if(typeTrimPoint === 'end') {
            const tp = {
                start : trimPoints[0] !== undefined ? trimPoints[0].start : newSecond - 60,
                end: newSecond
            }
            onChangeTrimPoints(tp)
        }
    }

    function handleTimeFieldKeyDown(event){
        if (event.key !== " "){
            event.stopPropagation();
        }
    }

    return (
        <Box>
          <Grid container spacing={2} sx={{
              marginTop: theme.spacing.sm,
          }}>
              <Grid item xs={12} md={6} lg={4.5}>
                   <FormControl sx={{marginBottom: theme.spacing.md}} fullWidth={true}>
                       <StyledTimeField
                           label={"Start Trim Point"}
                           borderColor={theme.palette.white}
                           color={theme.palette.white}
                           format={"HH:mm:ss"}
                           valueField={trimPoints[0] !== undefined ? trimPoints[0].start: 0}
                           onChange={(newSeconds)=>{handleChangeTrimPoints('start',newSeconds)}}
                           onKeyDown={handleTimeFieldKeyDown}
                           disabled={trimPoints[0] === undefined || trimPoints[0].start === undefined}
                       />
                   </FormControl>
                  <TransparentButton
                      height={'55px'}
                      width={'100%'}
                      text={"Set Start Trim Point"}
                      onClick={()=>onSetTrimPoints('start')}
                      onKeyDown={(e) => e.stopPropagation()}
                      disabled={disableSetTrimPoints}
                  />
              </Grid>
              <Grid item xs={12} md={6} lg={4.5}>
                  <FormControl sx={{marginBottom: theme.spacing.md}} fullWidth={true}>
                      <StyledTimeField
                          label={"End Trim Point"}
                          borderColor={theme.palette.white}
                          color={theme.palette.white}
                          format={"HH:mm:ss"} valueField={trimPoints[0] !== undefined ? trimPoints[0].end: 0}
                          onChange={(newSeconds)=>{handleChangeTrimPoints('end',newSeconds)}}
                          onKeyDown={handleTimeFieldKeyDown}
                          disabled={trimPoints[0] === undefined || trimPoints[0].end === undefined}
                      />
                  </FormControl>
                  <TransparentButton
                      height={'55px'}
                      width={'100%'}
                      text={"Set End Trim Point"}
                      onClick={()=>onSetTrimPoints('end')}
                      disabled={disableSetTrimPoints}
                      onKeyDown={(e) => e.stopPropagation()}
                  />
              </Grid>
              <Grid item xs={12} md={12} lg={3}>
                  <Box sx={{marginBottom: theme.spacing.md}} fullWidth={true}>
                      <TransparentButton
                          width={'100%'}
                          height={'55px'}
                          text={"Reset Selection"}
                          onClick={resetTrimPoints}
                          onKeyDown={(e) => e.stopPropagation()}
                      />
                  </Box>
                  <TransparentButton
                      width={'100%'}
                      height={'55px'}
                      text={"Restore Trim Points"}
                      onClick={restoreTrimPoints}
                      disabled={disableRestoreTrimPoints}
                      onKeyDown={(e) => e.stopPropagation()}
                  />
              </Grid>
          </Grid>
        </Box>
    )
}